module.exports = __webpack_public_path__ + "grandeshistorias.jpg?504895a994563158cf90e639eca9437b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/grandeshistorias.jpg
// module id = 118
// module chunks = 0